import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, TextField } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useFormikContext } from 'formik';
import moment from 'moment';
import { EDateFormat } from 'src/enums';
import { CheckboxFormField } from 'lib/form/CheckboxFormField';
import { TextFormField } from 'lib/form/TextFormField';
import { IUserInfoForm } from '../../models';
import { EFormFields } from './enums';

interface IProps {
    isBirthDateDisabled: boolean;
    credentials: {
        id: string;
        provider: string;
    };
    isCredentialsDisabled?: boolean;
}

export const UserDetailsForm: React.FC<IProps> = ({
    isBirthDateDisabled,
    isCredentialsDisabled,
    credentials: { id, provider }
}) => {
    const { t } = useTranslation();
    const {
        values: { birthdate },
        setFieldValue
    } = useFormikContext<IUserInfoForm>();

    const handleDateChange = React.useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            setFieldValue(EFormFields.DATE_OF_BIRTH, e.target.value);
        },
        [setFieldValue]
    );

    return (
        <>
            <Grid container spacing={2}>
                <Grid size={6}>
                    <TextFormField
                        trimWhiteSpaces="sides"
                        name={EFormFields.FIRST_NAME}
                        label={t('FIRST_NAME')}
                    />
                </Grid>
                <Grid size={6}>
                    <TextFormField
                        trimWhiteSpaces="sides"
                        name={EFormFields.LAST_NAME}
                        label={t('LAST_NAME')}
                    />
                </Grid>
            </Grid>
            {provider && id && (
                <TextField
                    label={provider}
                    name={provider}
                    variant="outlined"
                    fullWidth
                    value={id}
                    disabled={isCredentialsDisabled}
                    color="secondary"
                    sx={{ mt: 2 }}
                />
            )}
            <TextField
                label={t('USER_DETAILS_BIRTHDATE_TITLE')}
                type="date"
                name={EFormFields.DATE_OF_BIRTH}
                variant="outlined"
                fullWidth
                onChange={handleDateChange}
                value={birthdate}
                sx={{ mt: 2 }}
                disabled={isBirthDateDisabled}
                color="secondary"
                slotProps={{
                    htmlInput: { max: moment().format(EDateFormat.ISO) },
                    inputLabel: {
                        shrink: true
                    }
                }}
            />
            <Box marginTop={2} display="flex" alignItems="center" justifyContent="space-between">
                <CheckboxFormField name={EFormFields.MARKETING} label={t('GDPR_MARKETING_CHECKBOX_TITLE')} />
            </Box>
        </>
    );
};
